import { useMemo } from 'react';

import type { Order } from '@src/domains/orders';
import {
  getSaleChangeComparisonAmounts,
  getSaleChangeTotalAmountCents,
  saleChangeSummaryHasComparison,
  type SaleChange,
} from '@src/domains/sale-changes';
import type { Sale } from '@src/domains/sales';

import { getSaleChangeSummaryItems } from '../core/getSaleChangeSummaryItems';

export type UseSaleChangeSummaryResult = {
  productCount: number;
  items: ReturnType<typeof getSaleChangeSummaryItems>;
  downAmount?: number;
  upAmount?: number;
  totalAmountCents: number;
  hasComparison: boolean;
};

export const useSaleChangeSummary = (
  saleChange?: SaleChange | null,
  sale?: Sale | null,
  order?: Order | null,
): UseSaleChangeSummaryResult => {
  const items = useMemo(
    () => (saleChange ? getSaleChangeSummaryItems(saleChange, sale, order) : []),
    [saleChange, sale, order],
  );
  const { downAmount, upAmount } = saleChange ? getSaleChangeComparisonAmounts(saleChange) : {};

  return {
    productCount: items.length,
    items,
    downAmount,
    upAmount,
    totalAmountCents: saleChange ? getSaleChangeTotalAmountCents(saleChange) : 0,
    hasComparison: saleChange ? saleChangeSummaryHasComparison(saleChange) : false,
  };
};

export default useSaleChangeSummary;
